import { render, staticRenderFns } from "./SuppliersSetting.vue?vue&type=template&id=27bf7622&"
import script from "./SuppliersSetting.vue?vue&type=script&lang=js&"
export * from "./SuppliersSetting.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports